import { Injector, Pipe, PipeTransform } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Pipe({
  name: 'humanizedDate',
  standalone: true,
})
export class HumanizedDatePipe implements PipeTransform {
  constructor(private injector: Injector) {}
  transform(value?: string | null, ...args: unknown[]): string | null {
    if (value) {
      const commonService = this.injector.get(CommonService);
      const date = new Date(value);
      const year = date.getFullYear();
      const month = commonService.getTranslatedMessage((date.getMonth() + 1).toString());
      const day = date.getDate();
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');

      return args.length > 0 && args[0] ? `${day} ${month} ${year}` : `${day} ${month} ${year} ${hour}:${minute}`;
    }

    return '';
  }
}
